import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import parse from 'html-react-parser';
import Image from '../Image';
import { Container, Row, Col } from '../ui/Wrapper';
import SectionTitle from '../ui/section-title';
import AccordionWrap from '../ui/accordion';
import VideoButton from '../ui/video-button';
import ModalVideo from '../ui/modal-video';
import {
  AboutAreaWrap,
  AboutTextBox,
  AboutImageBox,
  ImageBox1,
  ImageBox2,
  ImageBox3,
  ImageBox4,
  MainImageBox,
  VideoBtnWrap,
} from './styles';

const AccordionInfo = ({
  sectionTitleStyle,
  title,
  subtitle,
  items,
  videoLink,
  videoImage,
  images,
  onlyItems,
  noPadding,
}) => {
  let videoArr;
  let videoId;
  let videoChannel;
  if (videoLink) {
    videoArr = videoLink.split('=', -1);
    videoId = videoArr[1];
    videoChannel = videoLink.split('.')[1];
  }
  const [videoOpen, setVideoOpen] = useState(false);
  const modalVideoOpen = () => {
    setVideoOpen(true);
  };

  const modalVideoClose = () => {
    setVideoOpen(false);
  };
  return (
    <>
      <AboutAreaWrap noPadding={noPadding}>
        <Container fluid>
          <Row alignitems="center">
            <Col lg={onlyItems ? 12 : 6}>
              <AboutTextBox>
                <SectionTitle {...sectionTitleStyle} title={title} subtitle={subtitle} />
                <AccordionWrap>
                  <Accordion allowZeroExpanded preExpanded={[0]}>
                    {items.map((el, index) => {
                      return (
                        <AccordionItem id={el.id} key={index}>
                          <AccordionItemHeading>
                            <AccordionItemButton>{el.title}</AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>{parse(el.content)}</AccordionItemPanel>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </AccordionWrap>
              </AboutTextBox>
            </Col>
            {!onlyItems ? (
              <Col lg={6}>
                <AboutImageBox>
                  {images.first && (
                    <ImageBox1 className="animation_image one">
                      <Image fluid={images.first.childImageSharp.fluid} isAbsolute alt="About Banner" />
                    </ImageBox1>
                  )}
                  {images.second && (
                    <ImageBox2 className="animation_image two">
                      <Image fluid={images.second.childImageSharp.fluid} isAbsolute alt="About Banner" />
                    </ImageBox2>
                  )}
                  {videoImage && (
                    <MainImageBox>
                      <Image fluid={videoImage.childImageSharp.fluid} alt="About Banner" />
                      {videoLink && (
                        <VideoBtnWrap>
                          <VideoButton skin="primary" onClick={modalVideoOpen} />
                        </VideoBtnWrap>
                      )}
                    </MainImageBox>
                  )}
                  {images.third && (
                    <ImageBox3 className="animation_image three">
                      <Image fluid={images.third.childImageSharp.fluid} isAbsolute alt="About Banner" />
                    </ImageBox3>
                  )}
                  {images.fourth && (
                    <ImageBox4 className="animation_image four">
                      <Image fluid={images.fourth.childImageSharp.fluid} isAbsolute alt="About Banner" />
                    </ImageBox4>
                  )}
                </AboutImageBox>
              </Col>
            ) : null}
          </Row>
        </Container>
      </AboutAreaWrap>
      <ModalVideo channel={videoChannel} videoId={videoId} isOpen={videoOpen} onClose={modalVideoClose} />
    </>
  );
};

AccordionInfo.propTypes = {
  sectionTitleStyle: PropTypes.object,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      content: PropTypes.string,
    })
  ).isRequired,
  videoLink: PropTypes.string,
  videoImage: PropTypes.object,
  images: PropTypes.shape({
    first: PropTypes.object,
    second: PropTypes.object,
    third: PropTypes.object,
    fourth: PropTypes.object,
  }),
  onlyItems: PropTypes.bool,
  noPadding: PropTypes.bool,
};

AccordionInfo.defaultProps = {
  subtitle: null,
  sectionTitleStyle: {
    mb: '40px',
    align: 'left',
  },
  images: {},
  videoLink: null,
  videoImage: null,
  onlyItems: false,
  noPadding: false,
};

export default AccordionInfo;
